/**
 * File size limits (in MB) for portfolio uploads.
 * Driven by VITE_ env vars; fallbacks mirror the values in `.env.example`
 * and must stay in sync with the backend `config/upload-limits.php` values
 * consumed by the relevant FormRequests.
 */
export const PORTFOLIO_UPLOAD_LIMITS_MB = {
  /** Activity & task attachments — backend: UPLOAD_MAX_ATTACHMENT_SIZE (102400 KB) */
  ATTACHMENT: parseInt(
    import.meta.env.VITE_UPLOAD_MAX_ATTACHMENT_MB || "100",
    10,
  ),
  /** Student profile picture & banner — backend: UPLOAD_MAX_IMAGE_SIZE (25600 KB) */
  PROFILE_IMAGE: parseInt(
    import.meta.env.VITE_UPLOAD_MAX_PROFILE_IMAGE_MB || "25",
    10,
  ),
  /** Task / template / public-task banner — backend: UPLOAD_MAX_TASK_BANNER_SIZE (25600 KB) */
  TASK_BANNER: parseInt(
    import.meta.env.VITE_UPLOAD_MAX_TASK_BANNER_MB || "25",
    10,
  ),
  /** Video attachments — backend: UPLOAD_MAX_VIDEO_ATTACHMENT_SIZE (1048576 KB = 1 GB) */
  VIDEO_ATTACHMENT: parseInt(
    import.meta.env.VITE_UPLOAD_MAX_VIDEO_ATTACHMENT_MB || "1024",
    10,
  ),
};
